import { Button, Popover, Stack, Tooltip } from "@mui/material";
import React, { useCallback, useState } from "react";
import AddPNFSales from "../modals/AddPNFSales";
import AddPNFPurchase from "../modals/AddPNFPurchase";
import AddPNFCreditNote from "../modals/AddPNFCreditNote";
import AddPNFJournal from "../modals/AddPNFJournal";
import AddPNFDebitNote from "../modals/AddPNFDebitNote";
import { handleFreeze } from "../../utils/common";
import { useSelector } from "react-redux";

const buttonStyle = {
  borderRadius: 10,
  color: "#297179",
  backgroundColor: "#FFF",
  fontFamily: "overpass",
  fontWeight: "700",
  fontSize: 15,
  paddingTop: 0.5,
  paddingBottom: 0.5,
  PaddingLeft: 1,
  paddingRight: 1,
  marginBottom: 1,
};

function VoucherBtn({ item }) {
  // ==================== states =======================  //
  const [anchorEl, setAnchorEl] = useState(null);
  const [salesModal, setSalesModal] = useState(false);
  const [purchaseModal, setPurchaseModal] = useState(false);
  const [creditNoteModal, setCreditNoteModal] = useState(false);
  const [journalModal, setJournalModal] = useState(false);
  const [debitNoteModal, setDebitNoteModal] = useState(false);

  // ==================== -------- =======================  //

  // ==================== PopOver =======================  //
  const open = Boolean(anchorEl);
  const id = open ? `popover-${item.id}` : undefined;

  const handleClick = useCallback((event) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  }, []);

  const handleClose = () => {
    setAnchorEl(null);
  };


  // ==================== -------- =======================  //
  const Freeze = useSelector((state) => state.userPrefrenceandReducer?.financialYear?.freezestatus);

  return (
    <div
      key={item.id}
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      <Tooltip title="Create Voucher">
        <Button
          aria-describedby={id}
          size="small"
          variant="contained"
          sx={{
            minWidth: "32px",
            color: item.category === "Item" ? "forth" : "#ffff",
          }}
          disabled={item.category === "Category"}
          onClick={(e) => {
            e.stopPropagation();
            if (Freeze == 1) {
              return handleFreeze()
            }
            handleClick(e);
          }}
        >
          V
        </Button>
      </Tooltip>

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        <Stack direction="column" p={2}>
          <Button
            variant="outlined"
            color="info"
            sx={buttonStyle}
            onClick={(event) => {
              event.stopPropagation();
              setDebitNoteModal(true);
              handleClose();
            }}
          >
            Debit Note
          </Button>
          <Button
            variant="outlined"
            color="info"
            sx={buttonStyle}
            onClick={(event) => {
              event.stopPropagation();
              setCreditNoteModal(true);
              handleClose();
            }}
          >
            Credit Note
          </Button>
          <Button
            variant="outlined"
            color="info"
            sx={buttonStyle}
            onClick={(event) => {
              event.stopPropagation();
              setSalesModal(true);
              handleClose();
            }}
          >
            Sale/Income
          </Button>
          <Button
            variant="outlined"
            color="info"
            sx={buttonStyle}
            onClick={(event) => {
              event.stopPropagation();
              setPurchaseModal(true);
              handleClose();
            }}
          >
            Purchase/Expense
          </Button>
        </Stack>
      </Popover>

      <AddPNFSales open={salesModal} setOpen={setSalesModal} />
      <AddPNFPurchase open={purchaseModal} setOpen={setPurchaseModal} />
      <AddPNFCreditNote open={creditNoteModal} setOpen={setCreditNoteModal} />
      <AddPNFJournal open={journalModal} setOpen={setJournalModal} />
      <AddPNFDebitNote open={debitNoteModal} setOpen={setDebitNoteModal} />
      {/* <AddBalanceSheetPayment open={paymentModal} setOpen={setPaymentModal} />
      <AddBalanceSheetReceipt open={receiptModal} setOpen={setReceiptModal} /> */}
    </div>
  );
}

export default React.memo(VoucherBtn);
